<template>
  <ais-instant-search
    :search-client="searchClient"
    :index-name="indexName"
    :on-state-change="onStateChange"
    :future="{preserveSharedStateOnUnmount: false}"
  >
    <ais-search-box 
      :placeholder="placeholder"
      :submit-title="buttonText"
      :class-names="classNames"
    >
      <template #submit-icon>{{ trans('search') }}</template>
    </ais-search-box>
    <ais-configure 
      :attributesToSnippet="['text:20']"
      :filters="algoliaFilters"
      :hits-per-page.camel="5"
    ></ais-configure>
    <b-overlay :show="busy">
      <b-list-group v-if="!!search" class="mt-3">
        <ais-hits>
          <template #item="{ item }">
            <b-list-group-item :href="item.page_url" :target="target" @click="onClickSearchResult($event, item)" class="flex-column align-items-start">
              <p class="mb-1">
                <ais-snippet :hit="item" attribute="text" />
              </p>
              <small class="d-block text-muted">
                <ais-highlight :hit="item" attribute="page_title" />
              </small>
            </b-list-group-item>
          </template>
        </ais-hits>
      </b-list-group>
    </b-overlay>
  </ais-instant-search>
</template>

<style>
  .ais-Hits-list {
    margin-left: -40px;
  }
  .ais-SearchBox-input::-webkit-search-cancel-button {
    appearance: none;
  }
  .ais-Hits-list .list-group-item-action {
    color: #45526e !important;
  }
  .ais-Hits-list li{
    list-style-type: none;
  }
</style>

<script>
  import { AisInstantSearch, AisSearchBox, AisHits, AisHighlight, AisSnippet, AisConfigure } from 'vue-instantsearch';
  import { liteClient as algoliasearch } from 'algoliasearch/lite';

  export default {
    props: {
      organization: Object,
      block: Object, // Can be null
      page: Object, // Can be null
      target: String, // Can be undefined
      btnVariant: {
        type: String,
        default: 'primary',
      },
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        search: null,
        searchClient: algoliasearch("ECVWCO4IKP","22b0eb24f6f00f8364891291077bbca0"),
      }
    },
    components: {
      AisInstantSearch,
      AisSearchBox,
      algoliasearch,
      AisHits,
      AisHighlight,
      AisSnippet,
      AisConfigure
    },
    computed: {
      placeholder() {
        return !!this.block && !!this.block.options ?
          (this.block.options.placeholder || trans('keywords')) :
          trans('keywords')
      },
      buttonText() {
        return !!this.block && !!this.block.options ?
          (this.block.button_text || this.block.options.cta || trans('search')) :
          trans('search')
      },
      algoliaFilters() {
        return `lang:${!!this.page && !!this.page.locale ? this.page.locale : this.organization.locale}`
      },
      indexName() {
        return this.organization.id.toString()
      },
      classNames() {
        return {
          'ais-SearchBox-input': 'form-control d-inline-block w-50 mb-2 mr-3',
          'ais-SearchBox-submit': `btn btn-${this.btnVariant} mb-2 d-inline-block`,
          'ais-SearchBox-reset': this.search ? 'btn d-inline-block pt-0' : 'd-none',
        }
      },
    },
    methods: {
      onStateChange(event) {
        if (!!event.uiState[this.indexName]) {
          this.search = event.uiState[this.indexName].query || null
        }
        event.setUiState(event.uiState)
      },
      onClickSearchResult(e, item) {
        if (!this.target) e.preventDefault()
        this.busy = true
        let url = `/org/${this.organization.id}/algolia_search`
        url += `?search=${encodeURIComponent(this.search)}`
        url += `&text=${encodeURIComponent(_.ckeditorHtmlToText(item.text)).substring(0, 500)}`
        url += `&page_url=${encodeURIComponent(item.page_url)}`
        url += `&page_title=${encodeURIComponent(item.page_title)}`
        axios.get(url)
        .then(response => {
          if (!this.target) {
            window.location = item.page_url
          } else {
            this.busy = false
            this.$emit('navigated')
          }
        })
        .catch(error => {
          if (!this.target) {
            window.location = item.page_url
          } else {
            this.busy = false
            this.$emit('navigated')
          }
        })
      },
      setFocusOnInput() {
        let input = this.$el.querySelector('input.ais-SearchBox-input.form-control')
        if (!!input) input.focus()
      },
      getInputValue() {
        let input = this.$el.querySelector('input.ais-SearchBox-input.form-control')
        return !!input ? input.value : null
      },
    },
    mounted() {
      window.algoliaSearch = this
      setTimeout(() => {
        this.setFocusOnInput()        
      }, 300)
    },
  }
</script>